import React, { useState, useEffect, useRef } from "react";
import Grid from "./grid";
// import FileUploadPractice from "./fileUploadPractice";
// import moment from "moment";
// import Highcharts from "highcharts";
// import {
//   Popover,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   Button,
// } from "@mui/material";

// import Drilldown from "highcharts/modules/drilldown";
// import AutoComplete from "components/Custom/AutoComplete";
// import TxtBox from "components/Custom/TxtBox";
// import Btn from "components/Custom/Btn";
// import SkeletonBox from "components/Custom/SkeletonBox";
// import HGraph from "components/Custom/HGraph";
// import ChkBox from "components/Custom/ChkBox";

// import { FORMATS, GRAPH_TYPES } from "common/config";
// import { REPORTS_APIs } from "apihandlers/reports";
// import { MASTER_APIs } from "apihandlers/master";
// import { LABELS } from "common/lables";
// import { DateFunctions } from "common//datefunctions";

// Drilldown(Highcharts);

const GraphDashboard = () => {
  const dealersRef: any = useRef(null);
  const viewRef: any = useRef(null);
  const filterRef: any = useRef(null);

  //   const [loading, setLoading] = useState<boolean>(false);
  //   const [chartData, setChartData] = useState<any>([]); // API Response
  //   const [filteredChartData, setFilteredChartData] = useState<any>(null); // after filter
  //   //make another state

  //   const [filteredCustomers, setFilteredCustomers] = useState([]);
  //   const [filteredDays, setFilteredDays] = useState([]); //after filter

  //   const [dealers, setDealers] = useState<any>([]);
  //   const [view, setView] = useState<any>([
  //     {
  //       id: "view1",
  //       label: "View1",
  //     },
  //     {
  //       id: "view2",
  //       label: "View2",
  //     },
  //     {
  //       id: "view3",
  //       label: "View3",
  //     },
  //   ]);
  //   const [filterDropdown, setFilterdropdown] = useState([]);
  //   const [popstatus, setPopstatus] = useState(true);
  //   const [popStatus, setPopStatus] = useState(true);
  //   const [anchorEl, setAnchorEl] = useState();
  //   const [anchorEld, setAnchorEld] = useState();

  //   const [dayFilterDropdown, setDayFilterDropdown] = useState([]);

  //   useEffect(() => {
  //     getDealers();
  //   }, []);

  //   const getDealers = async () => {
  //     try {
  //       const args = {};
  //       const res: any = await MASTER_APIs.getOrgProfiles(args);
  //       if (res.status === 200) {
  //         setDealers(
  //           res.response.records.map((rec: any) => {
  //             return {
  //               id: rec.id,
  //               label: rec.organizationName,
  //             };
  //           })
  //         );
  //       }
  //     } catch (error) {
  //       console.log("getDealers: ", error);
  //     }
  //   };

  //   const onLoadChart = () => {
  //     const dealer = dealersRef.current.selectedValue.id;
  //     const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
  //       .value;
  //     const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
  //     const view = viewRef.current.selectedValue.id;
  //     const args = {
  //       fromDt,
  //       toDt,
  //       dealer,
  //       view,
  //       customerId: "5",
  //     };
  //     console.log(args);
  //     REPORTS_APIs.getChartData(args).then((res: any) => {
  //       const response: any = res.response;
  //       const { status } = res;
  //       let list = response.chartData;
  //       let customers = list.map((customer) => {
  //         return {
  //           id: "cust" + customer.id,
  //           label: customer.name,
  //           checked: true,
  //         };
  //       });
  //       let cArr = customers.map((c) => {
  //         return c.id;
  //       });
  //       setFilteredCustomers(["custAll", ...cArr]);

  //       let days = list[0].data.map((day) => {
  //         return {
  //           id: day.key,
  //           label: day.key,
  //         };
  //       });

  //       let dArr = days.map((d) => {
  //         return d.id;
  //       });
  //       setFilteredDays(["All", ...dArr]);

  //       setChartData(list);

  //       setFilterdropdown([
  //         {
  //           id: "custAll",
  //           label: "All",
  //           checked: true,
  //         },
  //         ...customers,
  //       ]);
  //       setDayFilterDropdown([
  //         {
  //           id: "All",
  //           label: "All",
  //           checked: true,
  //         },
  //         ...days,
  //       ]);
  //     });
  //   };

  //   const open = Boolean(anchorEl);
  //   const id = open ? "simple-popover" : undefined;

  //   const open1 = Boolean(anchorEld);
  //   const id1 = open1 ? "simple-popover" : undefined;

  //   const handlePopStatus = (event) => {
  //     setAnchorEl(event.currentTarget);
  //     setPopstatus(true);
  //   };

  //   const handlePopstatus1 = (event) => {
  //     setAnchorEld(event.currentTarget);
  //     setPopStatus(true);
  //   };

  //   //Old on filter change;
  //   // const onFilterChange = (e, f) => {
  //   //   const tmpDropdown = filterDropdown.map((item) => {
  //   //     if (item.id === f) {
  //   //       item.checked = !item.checked;
  //   //     }
  //   //     return item;
  //   //   });
  //   //   setFilterdropdown(tmpDropdown);
  //   //   let selectedCustomers = [];
  //   //   if (f === "custAll") {
  //   //     const isChecked = (document.getElementById(f) as HTMLInputElement)
  //   //       .checked;
  //   //     if (isChecked) {
  //   //       selectedCustomers = filterDropdown.map((v) => {
  //   //         return Number(v.id.replace("cust", ""));
  //   //       });
  //   //       const tmpDropdown = filterDropdown.map((item) => {
  //   //         item.checked = true;
  //   //         return item;
  //   //       });
  //   //       setFilterdropdown(tmpDropdown);
  //   //     } else {
  //   //       const tmpDropdown = filterDropdown.map((item) => {
  //   //         item.checked = false;
  //   //         return item;
  //   //       });
  //   //       setFilterdropdown(tmpDropdown);
  //   //     }
  //   //   } else {
  //   //     // All Unselected
  //   //     selectedCustomers = filterDropdown.filter((item) => {
  //   //       if (item.id === "custAll") {
  //   //         item.checked = false;
  //   //       }
  //   //       return item.checked;
  //   //     });
  //   //     selectedCustomers = selectedCustomers.map((s) => {
  //   //       return Number(s.id.replace("cust", ""));
  //   //     });
  //   //     const isChecked = (document.getElementById(f) as HTMLInputElement)
  //   //       .checked;
  //   //     if (isChecked) {
  //   //       if (selectedCustomers.length === filterDropdown.length - 1) {
  //   //         let tmpList = filterDropdown;
  //   //         tmpList[0].checked = true;
  //   //         setFilterdropdown(tmpList);
  //   //       }
  //   //     }
  //   //   }
  //   //   const filteredCustomers = chartData.filter((item) => {
  //   //     return selectedCustomers.indexOf(item.id) > -1;
  //   //   });
  //   //   console.log(
  //   //     "selectedCustomers:",
  //   //     selectedCustomers,
  //   //     filteredCustomers.length,
  //   //     chartData.length
  //   //   );
  //   //   setFilteredChartData(filteredCustomers);
  //   // };

  //   const onFilterCustomer = (check, id) => {
  //     console.log("id", id);
  //     let tmplist = filteredCustomers;
  //     if (filteredCustomers.indexOf(id) === -1) {
  //       tmplist.push(id);
  //     } else {
  //       tmplist = filteredCustomers.filter((i) => i != id);
  //     }
  //     if (id == "custAll") {
  //       if (check) {
  //         tmplist = filteredCustomers;
  //       } else {
  //         tmplist = [];
  //       }
  //     } else {
  //       if (tmplist.length !== filteredCustomers.length) {
  //         tmplist = tmplist.filter((w) => w !== "custAll");
  //       }
  //     }
  //     setFilteredCustomers([...tmplist]);
  //     onChartFilter(tmplist, filteredDays);
  //   };

  //   const onDaysFilter = (check, id) => {
  //     let daysList = filteredDays;
  //     if (daysList.indexOf(id) === -1) {
  //       daysList.push(id);
  //     } else {
  //       daysList = filteredDays.filter((j) => j != id);
  //     }
  //     if (id == "All") {
  //       if (check) {
  //         daysList = filteredDays;
  //       } else {
  //         daysList = [];
  //       }
  //     } else {
  //       if (daysList.length !== filteredDays.length) {
  //         daysList = daysList.filter((w) => w !== "All");
  //       }
  //     }
  //     setFilteredDays([...daysList]);
  //     onChartFilter(filteredCustomers, daysList);
  //   };

  //   const onChartFilter = (c, d) => {
  //     c = c.map((n) => n.replace("cust", ""));
  //     console.log("onChartFilter:", c, d, chartData);
  //     if (c.indexOf("All") > -1 && d.indexOf("All") > -1) {
  //       // All - All
  //       setFilteredChartData(chartData);
  //     } else if (c.indexOf("All") > -1 && d.indexOf("All") === -1) {
  //       // All - []
  //       let fData: any = [];
  //       for (let m = 0; m < chartData.length; m++) {
  //         const item = chartData[m];
  //         const itemData = item.data.map((k) => k.key); // ["2023-05-06","2023-05-09"]
  //         let items = [];
  //         for (let i = 0; i < itemData.length; i++) {
  //           // If found => push
  //           if (d.indexOf(itemData[i]) > -1) {
  //             items.push(item.data[i]);
  //           }
  //         }
  //         item["data"] = items;
  //         if (items.length > 0) {
  //           fData.push(item);
  //         }
  //       }
  //       // setFilteredChartData(customerState);
  //       console.log("CustomerState:", chartData, fData);
  //     } else if (c.indexOf("All") === -1 && d.indexOf("All") > -1) {
  //       // [] - All
  //       const fData = chartData.filter((item) => {
  //         return c.indexOf(item.id.toString()) > -1;
  //       });
  //       console.log("setFilteredChartData:", c, fData, chartData);
  //       setFilteredChartData(fData);
  //       //   } else {
  //       //     const allCustomerStates = chartData.filter((item) => {
  //       //       c.includes(chartData.id);
  //       //       // console.log("Allcustomer", allCustomerStates);
  //       //     });
  //       //     const allDayStates = chartData.filter((item) => {
  //       //       d.includes(chartData.id);
  //       //       // console.log("All days", allDayStates);
  //       //     });
  //     }
  //   };

  //   const handlePopoverClose = () => {
  //     setPopstatus(false);
  //     setAnchorEl(null);
  //   };

  //   const handlePopoverClose1 = () => {
  //     setPopStatus(false);
  //     setAnchorEld(null);
  //   };

  //   let series = [];
  //   let drilldownSeries = [];
  //   // DUMMY DATA FOR REF:
  //   // series = [
  //   //   {
  //   //     name: "Jan",
  //   //     y: 100,
  //   //     drilldown: "Jan",
  //   //   },
  //   //   {
  //   //     name: "Feb",
  //   //     y: 50,
  //   //     drilldown: "Feb",
  //   //   },
  //   //   {
  //   //     name: "Mar",
  //   //     y: 30,
  //   //     drilldown: "Mar",
  //   //   },
  //   //   {
  //   //     name: "Apr",
  //   //     y: 40,
  //   //     drilldown: "Apr",
  //   //   },
  //   // ];
  //   // drilldownSeries = [
  //   //   {
  //   //     id: "Jan",
  //   //     name: "Jan",
  //   //     data: [
  //   //       {
  //   //         name: "Week1",
  //   //         y: 30,
  //   //         drilldown: "Week1",
  //   //       },
  //   //       {
  //   //         name: "Week2",
  //   //         y: 50,
  //   //         drilldown: "Week2",
  //   //       },
  //   //     ],
  //   //   },
  //   //   {
  //   //     id: "Week1",
  //   //     name: "Week1",
  //   //     data: [
  //   //       ["Day1", 10],
  //   //       ["Day2", 20],
  //   //     ],
  //   //   },
  //   //   {
  //   //     id: "Week2",
  //   //     name: "Week2",
  //   //     data: [
  //   //       ["Day1", 25],
  //   //       ["Day2", 25],
  //   //     ],
  //   //   },
  //   // ];

  //   // Create JSON object hierarchy
  //   const seriesJson = {};
  //   const data = filteredChartData ? filteredChartData : chartData;
  //   for (let s = 0; s < data.length; s++) {
  //     const customer = data[s];
  //     const dateList = customer.data;
  //     for (let d = 0; d < dateList.length; d++) {
  //       const date = dateList[d].key;
  //       const dateValue = dateList[d].value;
  //       const monthNum = Number(
  //         DateFunctions.getFormatedDate(date, FORMATS.SQL_DATE_ONLY, "MM")
  //       );
  //       const weekNum = Number(moment(date, FORMATS.SQL_DATE_ONLY).week());
  //       const day = Number(
  //         DateFunctions.getFormatedDate(date, FORMATS.SQL_DATE_ONLY, "DD")
  //       );
  //       if (!seriesJson[monthNum]) {
  //         seriesJson[monthNum] = {};
  //       }
  //       if (!seriesJson[monthNum][weekNum]) {
  //         seriesJson[monthNum][weekNum] = {};
  //       }
  //       if (!seriesJson[monthNum][weekNum][day]) {
  //         seriesJson[monthNum][weekNum][day] = 0;
  //       }
  //       seriesJson[monthNum][weekNum][day] += dateValue;
  //     }
  //   }

  //   for (let monthKey in seriesJson) {
  //     let monthName = moment(monthKey, "M").format("MMM");
  //     if (!series[monthKey]) {
  //       series[monthKey] = {
  //         name: monthName,
  //         y: 0,
  //         drilldown: monthName,
  //       };
  //     }
  //     if (!drilldownSeries[monthKey]) {
  //       drilldownSeries[monthKey] = {
  //         id: monthName,
  //         name: monthName,
  //         data: [],
  //       };
  //     }
  //     let weekJson = {};
  //     for (let weekNo in seriesJson[monthKey]) {
  //       if (!weekJson[weekNo]) {
  //         weekJson[weekNo] = {
  //           name: "w-" + weekNo,
  //           y: 0,
  //           drilldown: "w-" + weekNo,
  //         };
  //       }
  //       // for drilldown key
  //       if (!drilldownSeries["w-" + weekNo]) {
  //         drilldownSeries["w-" + weekNo] = {
  //           id: "w-" + weekNo,
  //           name: "w-" + weekNo,
  //           data: [],
  //         };
  //       }
  //       let dayJson = {};
  //       for (let day in seriesJson[monthKey][weekNo]) {
  //         const val = seriesJson[monthKey][weekNo][day];
  //         series[monthKey]["y"] += val;
  //         weekJson[weekNo]["y"] += val;
  //         if (!dayJson[day]) {
  //           dayJson[day] = [day, val];
  //         }
  //       }
  //       drilldownSeries["w-" + weekNo]["data"] = Object.values(dayJson);
  //     }
  //     drilldownSeries[monthKey]["data"] = Object.values(weekJson);
  //   }

  //   // Converting to Object to Array
  //   series = Object.values(series);
  //   drilldownSeries = Object.values(drilldownSeries);

  //   // console.log("series:", series, drilldownSeries);

  //   const options = {
  //     chart: {
  //       type: "column",
  //     },
  //     title: {
  //       align: "left",
  //       text: "Browser market shares. January, 2022",
  //     },
  //     subtitle: {
  //       align: "left",
  //       text: 'Click the columns to view versions. Source: <a href="http://statcounter.com" target="_blank">statcounter.com</a>',
  //     },
  //     accessibility: {
  //       announceNewData: {
  //         enabled: true,
  //       },
  //     },
  //     xAxis: {
  //       type: "category",
  //     },
  //     yAxis: {
  //       title: {
  //         text: "Total percent market share",
  //       },
  //     },
  //     legend: {
  //       enabled: false,
  //     },
  //     plotOptions: {
  //       series: {
  //         borderWidth: 0,
  //         dataLabels: {
  //           enabled: true,
  //           format: "{point.y:.1f}%",
  //         },
  //       },
  //     },
  //     tooltip: {
  //       headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
  //       pointFormat:
  //         '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
  //     },
  //     series: [
  //       {
  //         name: "Sales",
  //         colorByPoint: true,
  //         data: series,
  //       },
  //     ],
  //     drilldown: {
  //       series: drilldownSeries,
  //     },
  //   };

  return (
    <>
      <Grid />
      {/* <FileUploadPractice /> */}
    </>
    //     <>
    //       <div className="graphDashboardWrapper flexRow">
    //         <div className="formGroup width30">
    //           <label>{LABELS.DEALER}</label>
    //           <AutoComplete
    //             list={dealers}
    //             childRef={dealersRef}
    //             defaultValue={null}
    //             placeholder={"Select Dealer"}
    //             // onChange={() => getCustomers()}
    //           />
    //         </div>

    //         <div
    //           style={{
    //             display: "flex",
    //             marginRight: 15,
    //             marginLeft: 15,
    //             justifyContent: "",
    //             alignItems: "center",
    //           }}
    //         >
    //           <label
    //             style={{
    //               fontWeight: "500",
    //               fontSize: 14,
    //               marginTop: 6,
    //               marginRight: 8,
    //             }}
    //           >
    //             {LABELS.FROM_DATE}
    //           </label>
    //           <TxtBox
    //             type={"date"}
    //             id="fromDt"
    //             defaultValue={DateFunctions.getDate("today", "from", "YYYY-MM-DD")}
    //           />
    //         </div>

    //         <div
    //           style={{
    //             display: "flex",
    //             marginRight: 15,
    //             justifyContent: "center",
    //             alignItems: "center",
    //           }}
    //         >
    //           <label
    //             style={{
    //               fontWeight: "500",
    //               fontSize: 14,
    //               marginTop: 6,
    //               marginRight: 8,
    //             }}
    //           >
    //             {LABELS.TO_DATE}
    //           </label>
    //           <TxtBox
    //             type={"date"}
    //             id="toDt"
    //             defaultValue={DateFunctions.getDate(
    //               "thismonth",
    //               "to",
    //               "YYYY-MM-DD"
    //             )}
    //           />
    //         </div>
    //         <div className="formGroup width30">
    //           <label>{LABELS.VIEW}</label>
    //           <AutoComplete
    //             list={view}
    //             childRef={viewRef}
    //             defaultValue={null}
    //             placeholder={"Select View"}
    //             // onChange={() => getCustomers()}
    //           />
    //         </div>
    //         <div
    //           style={{
    //             display: "flex",
    //             marginLeft: "1rem",
    //             paddingTop: "1.4em",

    //             height: "50%",
    //           }}
    //         >
    //           <Btn text={LABELS.LOAD} onClick={onLoadChart} />
    //         </div>
    //       </div>

    //       <div>
    //         {!chartData ? (
    //           <div className="formGroup width30">
    //             <SkeletonBox />
    //           </div>
    //         ) : (
    //           chartData && (
    //             <div>
    //               <div
    //                 className=""
    //                 style={{ padding: "50px", display: "flex", width: "10%" }}
    //               >
    //                 {/* <AutoComplete
    //                   list={filterdropdown}
    //                   childRef={filterRef}
    //                   defaultValue={null}
    //                   placeholder={"Select Filter"}
    //                   onChange={onFilterChange}
    //                 /> */}

    //                 <Button
    //                   aria-describedby={id}
    //                   variant="contained"
    //                   // onClick={handleClick}
    //                   onClick={handlePopStatus}
    //                 >
    //                   {LABELS.FILTER}
    //                 </Button>
    //                 <Popover
    //                   id={id}
    //                   open={popstatus}
    //                   anchorEl={anchorEl}
    //                   onClose={handlePopoverClose}
    //                   anchorOrigin={{
    //                     vertical: "bottom",
    //                     horizontal: "left",
    //                   }}
    //                 >
    //                   <div style={{ marginLeft: "20px" }}>
    //                     {filterDropdown.map((item, index) => (
    //                       <tr>
    //                         <td>
    //                           <ChkBox
    //                             id={item.id}
    //                             text={item.label}
    //                             controlled={true}
    //                             checked={filteredCustomers.indexOf(item.id) > -1}
    //                             onChange={(e, f) => {
    //                               onFilterCustomer(e, f);
    //                             }}
    //                           />
    //                         </td>
    //                       </tr>
    //                     ))}
    //                   </div>
    //                 </Popover>
    //               </div>

    //               <div
    //                 className=""
    //                 style={{
    //                   padding: "50px",
    //                   display: "",
    //                   justifyContent: "space-between",
    //                   width: "10%",
    //                 }}
    //               >
    //                 {/* <AutoComplete
    //                   list={filterdropdown}
    //                   childRef={filterRef}
    //                   defaultValue={null}
    //                   placeholder={"Select Filter"}
    //                   onChange={onFilterChange}
    //                 /> */}

    //                 <Button
    //                   aria-describedby={id}
    //                   variant="contained"
    //                   // onClick={handleClick}
    //                   onClick={handlePopstatus1}
    //                 >
    //                   {LABELS.FILTER}
    //                 </Button>
    //                 <Popover
    //                   id={id1}
    //                   open={popStatus}
    //                   anchorEl={anchorEld}
    //                   onClose={handlePopoverClose1}
    //                   anchorOrigin={{
    //                     vertical: "bottom",
    //                     horizontal: "left",
    //                   }}
    //                 >
    //                   <div style={{ marginLeft: "20px" }}>
    //                     {dayFilterDropdown.map((item, index) => (
    //                       <tr>
    //                         <td>
    //                           <ChkBox
    //                             id={item.id}
    //                             text={item.label}
    //                             controlled={true}
    //                             checked={filteredDays.indexOf(item.id) > -1}
    //                             onChange={(e, f) => {
    //                               onDaysFilter(e, f);
    //                             }}
    //                           />
    //                         </td>
    //                       </tr>
    //                     ))}
    //                   </div>
    //                 </Popover>
    //               </div>

    //               <div className="chartDiv" style={{}}>
    //                 <HGraph
    //                   width={"50%"}
    //                   height={"60%"}
    //                   type={GRAPH_TYPES.COLUMN}
    //                   float={"right"}
    //                   // xAxis={xAxis}
    //                   // yAxis={yAxis}
    //                   title={"Column Graph"}
    //                   exportTitle={"Column Graph Record"}
    //                   xAxisTitle=""
    //                   yAxisTitle="Leads"
    //                   graphData={options}
    //                 />
    //               </div>
    //             </div>
    //           )
    //         )}
    //       </div>
    //     </>
  );
};

export default GraphDashboard;
